import { useEffect, useState } from 'react';

const API = process.env.REACT_APP_BACKEND_URL;

// Module-level cache to avoid refetching across components / route changes
const cache = new Map();

export function useStats(country) {
  const key = country || 'global';
  const [stats, setStats] = useState(() => cache.get(key) || null);
  const [loading, setLoading] = useState(!cache.has(key));

  useEffect(() => {
    let cancelled = false;
    if (cache.has(key)) {
      setStats(cache.get(key));
      setLoading(false);
      return;
    }
    const url = `${API}/api/stats/overview${country ? `?country=${country}` : ''}`;
    fetch(url)
      .then((r) => (r.ok ? r.json() : null))
      .then((data) => {
        if (cancelled || !data) return;
        cache.set(key, data);
        setStats(data);
      })
      .catch(() => {})
      .finally(() => !cancelled && setLoading(false));
    return () => { cancelled = true; };
  }, [key, country]);

  return { stats, loading };
}
